import React from 'react';
import AddressFilesView from '../components/AddressFilesView';

export default function SettlementStatements() {
  return (
    <AddressFilesView
      kind="settlement-statement"
      title="Settlement Statements"
      emptyKindLabel="settlement statement"
    />
  );
}
